import { fdeEntryApi } from 'src/api';

const api = {
  getMatchingEntriesByEntryId(entryId: string) {
    return fdeEntryApi.getPotentialMatches(entryId);
  }
};

export default api;
